export default __webpack_public_path__ + "static/media/defaultBcg.93bde64f.jpeg";